export default __webpack_public_path__ + "static/media/PhoneFrame.81440e45.png";